export default __webpack_public_path__ + "static/media/page-decoration-6.7f268895.svg";